/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockedTimeHistory/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronRight from 'DesignSystem/Svgs/Tysiav2ChevronRight/index'
import VerticalTimeline from 'DesignSystem/VerticalTimeline/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BlockedTimeHistory({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime/BlockedTimeDialog/BlockedTimeHistory"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventScheduleNoteHistoryValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note.history',
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="right"
 offsetMainAxis={0}
 offsetCrossAxis={0}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="BlockedTimeHistory.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2k2YxQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 text="View blocked time history"
/>
<div
  data-testid="BlockedTimeHistory.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
/>
<Tysiav2ChevronRight
  viewPath={`${viewPath}/Tysiav2ChevronRight`}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<div
  data-testid="BlockedTimeHistory.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z2k2YxQ': dtColorsWhite,'--bc-3-Z2k2YxQ': dtColorsNeutral300,'--btlr-4-Z2k2YxQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z2k2YxQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-6-Z2k2YxQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-Z2k2YxQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-8-Z2k2YxQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-9-Z2k2YxQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-10-Z2k2YxQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-Z2k2YxQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-12-Z2k2YxQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<VerticalTimeline
  viewPath={`${viewPath}/VerticalTimeline`}
 data="event.schedule_note.history"
 history={eventScheduleNoteHistoryValueData}
/>
</div>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}